import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

import { Button } from "@/components/ui/button";
import { m } from "@/paraglide/messages.js";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  const dark = mounted && resolvedTheme === "dark";

  const onToggle = React.useCallback(() => {
    if (!mounted) return;
    setTheme(dark ? "light" : "dark");
  }, [dark, mounted, setTheme]);

  return (
    <Button
      aria-label={dark ? m.switch_to_light_theme() : m.switch_to_dark_theme()}
      variant="ghost"
      size="icon-sm"
      onClick={onToggle}
    >
      {dark ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </Button>
  );
}
